<template>
    <div>
        <section>
            <div class="full-width-light">
                <div class="title-main">
                    <div class="element-percent">
                        <h1 class="text-center">{{ detail.name }}</h1>
                        <div class="text-center" v-if="userType === 'Individual'">
                            <button class="ra-btn" id="register2" v-on:click="registerWebinar($event)"
                                    :data-key="detail.webinar_enc_id" v-if="!detail.is_registered">Register Now
                            </button>
                            <button class="ra-btn disabled" type="button" v-else>Registered</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="webinar-detail-bg">
            <div class="ts-count-down">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-10 col-lg-offset-1">
                            <div class="countdown gradient clearfix" v-if="!detail.is_started">
                                <div class="counter-item">
                                    <span class="days">{{ days }}</span>
                                    <div class="smalltext">Days</div>
                                    <b>:</b>
                                </div>
                                <div class="counter-item">
                                    <span class="hours">{{ hours }}</span>
                                    <div class="smalltext">Hours</div>
                                    <b>:</b>
                                </div>
                                <div class="counter-item">
                                    <span class="minutes">{{ minutes }}</span>
                                    <div class="smalltext">Minutes</div>
                                    <b>:</b>
                                </div>
                                <div class="counter-item">
                                    <span class="seconds">{{ seconds }}</span>
                                    <div class="smalltext">Seconds</div>
                                </div>
                            </div>
                            <div class="text-center gradient" v-else-if="detail.is_registered && detail.is_started">
                                <router-link class="joinBtn"
                                             :to="{path: '/dashboard/webinar-view?id=' + detail.event.session_enc_id}">
                                    Click
                                    here to Join
                                </router-link>
                            </div>
                            <div class="text-center gradient" v-else>
                                <a class="joinBtn" href="javascript:;"
                                   @click="alertModal('Please Register to Join this Webinar');">
                                    Click here to Join
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="webinar-details">
                <div class="container">
                    <div class="row padd-top-20">
                        <div class="col-md-7 mx-auto">
                            <h2 class="section-title">
                                Webinar Details
                            </h2>
                        </div>
                        <div class="col-md-5 text-right">
                            <div class="avatars">
                                <ul class="ask-people" v-if="detail.webinarRegistrations">
                                    <li v-for="(av, index) in detail.webinarRegistrations.slice(0,6)">
                                        <img :src="av.image">
                                    </li>
                                </ul>
                                <p v-if="detail.registered_count"><span v-html="detail.registered_count"></span>
                                    People Registered</p>
                            </div>
                            <div v-if="userType === 'Individual'">
                                <button class="ra-btn" id="register" v-on:click="registerWebinar($event)"
                                        :data-key="detail.webinar_enc_id" v-if="!detail.is_registered">Register
                                </button>
                                <button class="ra-btn disabled" type="button" v-else>Registered</button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="webinar-description">
                                <p v-html="detail.description">
                                </p>
                            </div>
                            <div class="sidebar text-center">
                                <div class="dis-flex">
                                    <p v-if="detail.event"><i class="fas fa-calendar-day"></i> <span
                                        v-html="getFullDate(detail.event.start_datetime)"></span>
                                    </p>
                                    <p v-if="detail.event"><i class="far fa-clock"></i> <span
                                        v-html="getTime(detail.event.start_datetime)"></span> IST</p>
                                    <p><i class="fas fa-users"></i> {{ detail.seats }} Seats</p>
                                    <p v-if="detail.speaker_count"><i class="fas fa-microphone-alt"></i>
                                        {{ detail.speaker_count }} Speakers
                                    </p>
                                    <p v-if="detail.price && detail.price != '0'"><i class="fas fa-rupee-sign"></i>
                                        {{ detail.price }}/-
                                    </p>
                                </div>
                                <div class="flex2">
                                    <div class="register-action" v-if="userType === 'Individual'">
                                        <button class="ra-btn ra-actions" id="interested"
                                                @click="webinarStatus($event,1)">Interested
                                        </button>
                                        <button class="ra-btn ra-actions" id="notInterested"
                                                @click="webinarStatus($event,2)">Not
                                            Interested
                                        </button>
                                        <button class="ra-btn ra-actions" id="attending"
                                                @click="webinarStatus($event,3)">Attending
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- sharing widget start -->
        <!--        <div class="container">-->
        <!--            <div class="row">-->
        <!--                <div class="col-md-12">-->
        <!--                    <div class="share-social">-->
        <!--                        <div class="whatsapp-share basis">-->
        <!--                            <a href="#" onclick="window.open('https://api.whatsapp.com/send?text=<?= $sharingLink ?>', '_blank', 'width=800,height=400,left=200,top=100')" class="share-elem-main">-->
        <!--                                <span><i class="fab fa-whatsapp"></i> Whatsapp</span>-->
        <!--                            </a>-->
        <!--                        </div>-->
        <!--                        <div class="teleg-share basis">-->
        <!--                            <a href="#" onclick="window.open('https://telegram.me/share/url?url=<?= $sharingLink ?>', '_blank', 'width=800,height=400,left=200,top=100')" class="share-elem-main">-->
        <!--                                <span><i class="fab fa-telegram-plane"></i> Telegram</span>-->
        <!--                            </a>-->
        <!--                        </div>-->
        <!--                        <div class="twi-share basis">-->
        <!--                            <a href="#" onclick="window.open('https://twitter.com/intent/tweet?text=<?= $sharingLink ?>', '_blank', 'width=800,height=400,left=200,top=100')" class="share-elem-main">-->
        <!--                                <span><i class="fab fa-twitter marg"></i> Twitter</span>-->
        <!--                            </a>-->
        <!--                        </div>-->
        <!--                        <div class="link-share basis">-->
        <!--                            <a href="#" onclick="window.open('https://www.linkedin.com/shareArticle?mini=true&url=<?= $sharingLink ?>', '_blank', 'width=800,height=400,left=200,top=100');" class="share-elem-main">-->
        <!--                                <span><i class="fab fa-linkedin-in marg"></i> LinkedIn</span>-->
        <!--                            </a>-->
        <!--                        </div>-->
        <!--                        <div class="reddit-share basis">-->
        <!--                            <a href="#" onclick="window.open('http://www.reddit.com/submit?url=<?= $sharingLink ?>', '_blank', 'width=800,height=400,left=200,top=100');" class="share-elem-main">-->
        <!--                                <span><i class="fab fa-reddit marg"></i> Reddit</span>-->
        <!--                            </a>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
        <!-- sharing widget end -->
        <!-- ts speaker start-->
        <!-- ts schedule start-->
        <section class="ts-schedule" v-if="detail.events">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 mx-auto">
                        <h2 class="section-title text-center">
                            <span>Schedule Details</span>
                            Event Schedules
                        </h2>
                        <div class="ts-schedule-nav">
                            <ul class="nav nav-tabs justify-content-center" role="tablist">
                                <li class="nav-item eventsList" v-for="(value, key) in detail.events">
                                    <a class="" title="Click Me" :href="'#'+generateTabId(key)" role="tab"
                                       data-toggle="tab">
                                        <h3><span v-html="getDate(parseDate(key)) + 'th'"></span>&nbsp;<span
                                            v-html="getMonth(parseDate(key))"></span></h3>
                                        <span v-html="getDay(parseDate(key))"></span>
                                    </a>
                                </li>
                            </ul>
                            <!-- Tab panes -->
                        </div>
                    </div><!-- col end-->

                </div><!-- row end-->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="tab-content schedule-tabs schedule-tabs-item">
                            <div role="tabpanel" class="tab-pane eventsListData" :id="generateTabId(key)"
                                 v-for="(value, key) in detail.events">
                                <div class="schedule-listing" v-for="list in value">
                                    <div class="schedule-slot-time">
                                        <span v-html="getFormattedTime(list.event_time)"></span> - <span
                                        v-html="getFormattedTime(list.endtime)"></span>
                                        {{ list.event_title }}
                                    </div>
                                    <div class="schedule-slot-info" v-for="listSpeakers in list.webinarSpeakers">
                                        <a href="javascript:;">
                                            <img class="schedule-slot-speakers" :src="listSpeakers.image"
                                                 :alt="listSpeakers.fullname">
                                        </a>
                                        <div class="schedule-slot-info-content">
                                            <h3 class="schedule-slot-title">{{ listSpeakers.fullname }}
                                                <!--                        <strong>{{ listSpeakers.designation }}</strong>-->
                                            </h3>
                                            <p>{{ listSpeakers.designation }}</p>
                                        </div>
                                        <!--Info content end -->
                                    </div><!-- Slot info end -->
                                </div>
                            </div><!-- tab pane end-->
                        </div>

                    </div>
                </div>
            </div><!-- container end-->
        </section>
        <!-- ts schedule end-->
        <section id="ts-speakers" class="ts-speakers speaker-classic">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 mx-auto">
                        <h2 class="section-title text-center">
                            <span>Listen to the</span>
                            Event Speakers
                        </h2>
                    </div><!-- col end-->
                </div><!-- row end-->
                <div class="row">
                    <div class="col-lg-3 col-md-6" v-for="sp in detail.speakers">
                        <div class="ts-speaker">
                            <div class="speaker-img">
                                <img class="img-fluid" :src="sp.image" style="min-height: 150px;">
                                <a href="javascript:;" class="view-speaker ts-image-popup" :data-key="sp.speaker_enc_id"
                                   @click="SpeakerModal($event)">
                                    <i class="fas fa-plus"></i>
                                </a>
                            </div>
                            <div class="ts-speaker-info">
                                <h3 class="ts-title"><a href="#">{{ sp.fullname }}</a></h3>
                                <p>
                                    {{ sp.designation }}
                                </p>
                            </div>
                        </div>
                    </div> <!-- col end-->
                </div><!-- row end-->
            </div><!-- container end-->
        </section>
        <!-- ts speaker end-->
        <!-- ts intro start -->
        <section class="ts-intro-outcome" v-if="detail.webinarOutcomes">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 mx-auto">
                        <h2 class="section-title text-center">
                            <span>Why Join us</span>
                            Event Outcomes
                        </h2>
                    </div>
                </div><!-- row end-->
                <div class="row">
                    <div class="col-lg-3 col-md-6 outcome-item" v-for="eo in detail.webinarOutcomes">
                        <div class="ts-single-outcome"
                             :style="'background-image: linear-gradient(110deg, #'+eo.bg_colour+' 25%, '+getRandomColor('#'+eo.bg_colour)+' 120%);'">
                            <img :src="eo.icon"/>
                            <h3 class="ts-title">{{ eo.name }}</h3>
                        </div><!-- single outcome end-->
                    </div><!-- col end-->
                </div>
            </div><!-- container end-->
        </section>
<!--        <section>-->
<!--            <div class="container-fluid">-->
<!--                <div class="row md-flex">-->
<!--                    <div class="col-md-6 ts-book-seat">-->
<!--                        <div class="book-seat-content text-center mb-100">-->
<!--                            <h3 class="section-title white">-->
<!--                                <img src="../../../public/images/logos-com/edupreneur_village.png"/>-->
<!--                                <br/>-->
<!--                                <br/>-->
<!--                                Edupreneur Village Challenge 2.0<br/><br/>-->
<!--                            </h3>-->
<!--                            <ul class="section-list">-->
<!--                                <li>For EdTech startups at an ideation / Validation stage</li>-->
<!--                                <li>Investment upto 25 lacs, Cash Prizes and Incubation Support</li>-->
<!--                                <li>Partnership with the Auro Scholar Programme of Sri Aurobindo Society</li>-->
<!--                                <li>Scholarship available for top 5 startups for Education Entrepreneurship-->
<!--                                    Certification Program-->
<!--                                </li>-->
<!--                            </ul>-->
<!--                            <div class="text-center" v-if="userType === 'Individual'">-->
<!--                                <button class="ra-btn" id="register3" v-on:click="registerWebinar($event)"-->
<!--                                        :data-key="detail.webinar_enc_id" v-if="!detail.is_registered">Join Webinar to-->
<!--                                    learn more-->
<!--                                </button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-md-6 ts-book-seat second">-->
<!--                        <div class="book-seat-content text-center mb-100">-->
<!--                            <h3 class="section-title white">-->
<!--                                <img-->
<!--                                    src="https://www.empoweryouth.com/assets/themes/ey/images/pages/webinar/red_bull_logo.png"/>-->
<!--                                <br/>-->
<!--                                <br/>-->
<!--                                Red Bull Basement University is where students come to innovate, collaborate, and drive-->
<!--                                change on campus through DIY-based technological solutions.-->
<!--                            </h3>-->
<!--                            <div class="text-center" v-if="userType === 'Individual'">-->
<!--                                <button class="ra-btn" id="register4" v-on:click="registerWebinar($event)"-->
<!--                                        :data-key="detail.webinar_enc_id" v-if="!detail.is_registered">Join Webinar to-->
<!--                                    learn more-->
<!--                                </button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                </div>-->
<!--            </div>-->
<!--        </section>-->
        <!-- book seat  end-->
        <SpeakerModal></SpeakerModal>
    </div>
</template>

<script>
import axios from 'axios'
import toastr from "../../../public/js/toastr";
import {paymentAccessToken} from "../../_helpers/apiRoute.js";
import SpeakerModal from '../../components/SpeakerModal';
import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

export default {
    components: {
        SpeakerModal
    },
    data: function () {
        return {
            days: "",
            hours: "",
            minutes: "",
            seconds: "",
            detail: "",
            webinarId: "",
            registered: true,
            userType: this.$store.getters.getUserType,
            speaker_data: []
        }
    },
    mounted() {
        var t = this;
        var url = this.$store.getters.getDomain;

        function getUrlVars() {
            var vars = {};
            var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                vars[key] = value;
            });
            return vars;
        }

        t.webinarId = getUrlVars()["id"];
        var axUrl;
        if (t.$store.getters.getUserType == 'Individual') {
            axUrl = `${url}api/v2/candhome/webinar-detail`;
        } else {
            axUrl = `${url}api/v2/webinars/detail`;
        }
        axios.post(axUrl, {webinar_id: t.webinarId}, {headers: requestHeaders()}).then(function (response) {
            if (response['data']['response']['status'] == 200) {
                t.detail = response['data']['response']['data'];
                t.countdown(response['data']['response']['data'].event.start_datetime);
                if (response['data']['response']['data'].interest_status) {
                    var selectedElem = response['data']['response']['data'].interest_status - 1;
                    var iBtn = document.getElementsByClassName('ra-actions');
                    iBtn[selectedElem].classList.add('active');
                }
                setTimeout(function () {
                    document.getElementsByClassName('eventsList')[0].classList.add('active');
                    document.getElementsByClassName('eventsListData')[0].classList.add('active');
                });
                // if(response['data']['response']['data'].seconds < 0){
                //   alert('Webinar Expired');
                //   t.$router.push({path: '/dashboard'})
                // }
            } else {
                alert('No webinar found');
                this.$router.push({path: '/dashboard'})
            }
        });
    },
    methods: {
        webinarStatus(event, status) {
            var element = event.currentTarget;
            var elems = document.getElementsByClassName('ra-btn');
            for (var i = 0; i < elems.length; i++) {
                if (elems[i].classList.contains('active')) {
                    elems[i].classList.remove('active');
                }
            }
            element.classList.add('active');
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/candhome/change-status`, {
                webinar_enc_id: t.webinarId,
                status: status
            }, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status']) {

                }
            });
        },
        registerWebinar(e) {
            var element = e.currentTarget;
            element.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
            var data_key = element.getAttribute('data-key');
            var t = this;
            var url = this.$store.getters.getDomain;
            axios.post(`${url}api/v2/webinars/join-webinar`, {webinar_id: data_key}, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 201) {
                    element.textContent = 'Registered';
                    element.disabled = true;
                    element.classList = "ra-btn ra-actions disabled";
                } else if (response['data']['response']['status'] == 200) {
                    t.paymentPage(response['data']['response']['callback'].payment_token, response['data']['response']['callback'].payment_enc_id, response['data']['response']['callback'].registration_enc_id)
                }
            });
        },
        countdown(e) {
            var t = this;
            var countDownDate = new Date(e).getTime();

            var x = setInterval(function () {

                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                t.days = Math.floor(distance / (1000 * 60 * 60 * 24));
                t.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                t.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                t.seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // Output the result in an element with id="demo"
                // document.getElementById("demo").innerHTML = days + "d " + hours + "h "
                //     + minutes + "m " + seconds + "s ";

                // If the count down is over, write some text
                if (distance < 0) {
                    clearInterval(x);
                    t.detail.is_started = true;
                }
            }, 1000);
        },
        paymentPage(paymentId, paymentEncId, registrationEncId) {
            var t = this;
            var options = {
                "key": paymentAccessToken(), // Enter the Key ID generated from the Dashboard
                "name": "MyEcampus",
                "description": "Webinar Registration Fees",
                // "image": "https://example.com/your_logo",
                "order_id": paymentId,
                "handler": function (response){
                    t.updateApplication(response.razorpay_payment_id,response.razorpay_signature, paymentEncId, registrationEncId,'captured');
                },
            };
            var rzp1 = new Razorpay(options);
            rzp1.open();
            rzp1.on('payment.failed', function (response){
                t.updateApplication('','', paymentEncId, registrationEncId,'failed');
            });
            // Layer.checkout({
            //         token: paymentId,
            //         accesskey: paymentAccessToken(),
            //     },
            //     function (response) {
            //         t.updateApplication(response, paymentEncId, registrationEncId);
            //         if (response.status == "captured") {
            //             // response.payment_token_id
            //             // response.payment_id
            //         } else if (response.status == "created") {
            //         } else if (response.status == "pending") {
            //         } else if (response.status == "failed") {
            //
            //         } else if (response.status == "cancelled") {
            //         }
            //     },
            //     function (err) {
            //         console.log(err)
            //         //integration errors
            //     }
            // );
        },
        updateApplication(paymentId,paymentSignature, paymentEncId, registrationEncId,status) {
            var t = this;
            showLoader()
            var url = this.$store.getters.getDomain;
            var res = {};
            // res['loan_app_id'] = loanAppId;
            // res['loan_payment_id'] = eduLoanId;
            res['payment_id'] = paymentId;
            // res['signature'] = paymentSignature;
            res['payment_status'] = status;
            res['payment_enc_id'] = paymentEncId;
            res['registration_enc_id'] = registrationEncId;
            // res['payment_enc_id'] = paymentEncId;
            // res['registration_enc_id'] = registrationEncId;
            axios.post(`${url}api/v2/webinars/update-status`, res, {
                headers: requestHeaders()
            }).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    toastr.success('Application Fees ' + res.payment_status, 'Success');
                    location.reload();
                    // t.$router.push({path: '/dashboard'});
                }
                hideLoader()
            })
                .catch(function (error) {
                    // t.getFeeComponents();
                })
        },
        SpeakerModal(event) {
            var element = event.currentTarget;
            var data_key = element.getAttribute('data-key');
            var t = this;
            var url = this.$store.getters.getDomain;
            axios.post(`${url}api/v2/webinars/speaker-detail`, {speaker_enc_id: data_key}, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.speaker_data = response['data']['response']['data'];
                    t.$children[0].getSpeakerData()
                    $('#speaker').modal('show');
                }
            });
        },
        alertModal(e) {
            alert(e);
        },
        getRandomColor(color) {
            var p = 1,
                temp,
                random = Math.random(),
                result = '#';

            while (p < color.length) {
                temp = parseInt(color.slice(p, p += 2), 16)
                temp += Math.floor((255 - temp) * random);
                result += temp.toString(16).padStart(2, '0');
            }
            return result;
        },
        parseDate(input) {
            var parts = input.split('/');
            // Note: months are 0-based
            return new Date(parts[2], parts[1] - 1, parts[0]);
        },
        generateTabId(input) {
            var parts = input.split('/');
            // Note: months are 0-based
            return this.getDay(new Date(parts[2], parts[1] - 1, parts[0])) + this.getDate(new Date(parts[2], parts[1] - 1, parts[0]));
        },
        getFormattedTime(e) {
            return e.replace(/:\d\d([ ap]|$)/, '$1')
        },
        getDay(e) {
            var d = new Date(e);
            var weekday = new Array(7);
            weekday[0] = "Sunday";
            weekday[1] = "Monday";
            weekday[2] = "Tuesday";
            weekday[3] = "Wednesday";
            weekday[4] = "Thursday";
            weekday[5] = "Friday";
            weekday[6] = "Saturday";

            return weekday[d.getDay()];
        },
        getDate(e) {
            var d = new Date(e);
            return d.getDate();
        },
        getMonth(e) {
            var d = new Date(e);
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "Sep", "Oct", "November", "December"];
            return months[d.getMonth()];
        },
        getFullDate(e) {
            var d = new Date(e);
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "Sep", "Oct", "November", "December"];
            return d.getDate() + " " + months[d.getMonth()] + " " + d.getFullYear();
        },
        getTime(e) {
            var d = new Date(e);
            return d.getHours() + ':' + d.getMinutes();
        },
    }
}
</script>

<style scoped>
.dis-flex {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    padding: 10px 0 0 0;
}

.flex2 {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 20px;
}

.dis-flex p {
    flex: 1;
    font-size: 16px;
    font-family: roboto;
}

.dis-flex p i {
    color: #00a0e3;
    padding-right: 5px;
}

@media screen and (max-width: 768px) {
    .dis-flex p {
        flex: auto;
        font-size: 16px;
        font-family: roboto;
    }

    .dis-flex {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
    }
}

.ask-people {
    margin-top: 10px;
    margin-left: 20px;
}

.sidebar h5 {
    font-size: 16px;
}

.ask-people li {
    width: 50px;
    height: 50px;
    border: 2px solid #fff;
    border-radius: 50%;
    display: inline-block;
    margin-right: -20px;
}

.ask-people li img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}

#footer {
    margin-top: 0px;
}

.webinar-details {
    font-family: roboto;
}

.webinar-title {
    text-align: center;
}

.webinar-title h1 {
    color: #fff;
    font-size: 20px;
}

.ts-speakers {
    padding-top: 120px;
    padding-bottom: 40px;
    position: relative;
    overflow: hidden;
}

.ts-speaker {
    position: relative;
    text-align: center;
    margin-bottom: 55px;
}

.ts-speaker .speaker-img {
    width: 255px;
    height: 255px;
    position: relative;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -ms-border-radius: 50%;
    overflow: hidden;
    margin: auto auto 20px;
}

.ts-speaker .speaker-img img {
    width: 100%;
    height: 270px;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
}

.ts-speaker .speaker-img:before {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: \'\';
    background: rgba(59, 29, 130, 0.5);
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    opacity: 0;
    z-index: 1;
}

.ts-speaker .view-speaker {
    position: absolute;
    left: 0;
    top: 70%;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    color: #fff;
    font-size: 22px;
    width: 50px;
    height: 50px;
    line-height: 48px;
    margin: auto;
    border: 2px solid #ddd;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -ms-border-radius: 50%;
    /*padding: 6px 0;*/
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    opacity: 0;
    z-index: 2;
}

.ts-speaker .ts-title {
    margin-bottom: 5px;
}

.ts-speaker .ts-title a {
    color: #222222;
}

.ts-speaker:hover .speaker-img img {
    -webkit-transform: scale(1.2);
    -ms-transform: scale(1.2);
    transform: scale(1.2);
}

.ts-speaker:hover .speaker-img:before {
    opacity: 1;
}

.ts-speaker:hover .view-speaker {
    top: 50%;
    opacity: 1;
}

.ts-speaker:hover .ts-title a {
    color: #e7015e;
}

.ts-speaker.white-text .ts-title a,
.ts-speaker.white-text p {
    color: #fff;
}

.speaker-classic {
    padding-top: 50px;
    margin-top: 50px;
    background-image: url('https://shshank.eygb.me/assets/themes/ey/images/pages/webinar/speakers-bg.png');
    background-repeat: no-repeat;
    background-size: cover;
}

.speaker-classic .ts-speaker {
    margin-bottom: 60px;
}

.speaker-classic .ts-speaker .speaker-img {
    width: 100%;
    height: auto;
    border-radius: 0;
    -webkit-border-radius: 0;
    -ms-border-radius: 0;
}

.speaker-classic .ts-speaker .ts-speaker-info {
    position: absolute;
    right: 0;
    bottom: -13px;
    background: #fff;
    z-index: 1;
    width: 90%;
    padding: 20px 0 10px;
}

.speaker-classic .ts-speaker .ts-speaker-info .ts-title {
    margin-bottom: 0;
}

.speaker-classic .ts-speaker .ts-speaker-info p {
    margin-bottom: 0;
}

.speaker-shap img {
    position: absolute;
    left: 0;
    top: 0;
    max-width: 100px;
}

.speaker-shap img.shap1 {
    top: 15%;
}

.speaker-shap img.shap2 {
    bottom: 0;
    left: auto;
    top: 35%;
    right: 0;
    margin: auto;
}

.speaker-shap img.shap3 {
    top: auto;
    bottom: -25px;
    margin: auto;
    left: 6%;
}

.ts-speaker-popup {
    background: #fff;
    padding: 0;
    position: relative;
}

.ts-speaker-popup .ts-speaker-popup-img img {
    width: 100%;
}

.ts-speaker-popup .ts-speaker-popup-content {
    padding: 60px 40px;
}

.ts-speaker-popup .ts-speaker-popup-content .ts-title {
    margin-bottom: 10px;
}

.ts-speaker-popup .ts-speaker-popup-content .speakder-designation {
    display: block;
    font-size: 14px;
    margin-bottom: 20px;
}

.ts-speaker-popup .ts-speaker-popup-content .company-logo {
    margin-bottom: 15px;
}

.ts-speaker-popup .ts-speaker-popup-content p {
    margin-bottom: 25px;
}

.ts-speaker-popup .ts-speaker-popup-content h4 {
    font-size: 20px;
    font-weight: 700;
}

.ts-speaker-popup .ts-speaker-popup-content .session-name {
    margin-bottom: 15px;
}

.ts-speaker-popup .ts-speaker-popup-content .speaker-session-info p {
    color: #e7015e;
    margin-bottom: 30px;
}

.ts-speaker-popup .ts-speaker-popup-content .ts-speakers-social a {
    color: #ababab;
    margin-right: 18px;
}

.ts-speaker-popup .ts-speaker-popup-content .ts-speakers-social a:hover {
    color: #e7015e;
}

.ts-speaker-popup button.mfp-close {
    font-size: 30px;
}

.mfp-hide {
    display: none !important;
}

.mfp-fade.mfp-bg {
    opacity: 0;
    -webkit-transition: all 0.15s ease-out;
    -moz-transition: all 0.15s ease-out;
    transition: all 0.15s ease-out;
}

.mfp-fade.mfp-bg.mfp-ready {
    opacity: 0.8;
}

.mfp-fade.mfp-bg.mfp-removing {
    opacity: 0;
}

.mfp-fade.mfp-wrap .mfp-content {
    opacity: 0;
    -webkit-transition: all 0.15s ease-out;
    -moz-transition: all 0.15s ease-out;
    transition: all 0.15s ease-out;
}

.mfp-fade.mfp-wrap.mfp-ready .mfp-content {
    opacity: 1;
}

.mfp-fade.mfp-wrap.mfp-removing .mfp-content {
    opacity: 0;
}

/*outcome*/
.ts-intro-outcome {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    padding: 70px;
}

.ts-single-outcome {
    text-align: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -ms-border-radius: 50%;
    width: 250px;
    height: 250px;
    background-image: -webkit-linear-gradient(340deg, #fc6076 0%, #ff9a44 100%);
    background-image: -o-linear-gradient(340deg, #fc6076 0%, #ff9a44 100%);
    background-image: linear-gradient(110deg, #fc6076 0%, #ff9a44 100%);
    -webkit-box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.12);
    box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.12);
    padding: 55px 0;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    margin-bottom: 30px;
}

.ts-single-outcome i {
    font-size: 80px;
    color: #fff;
    display: block;
    margin-bottom: 30px;
}

.ts-single-outcome img {
    max-height: 80px;
}

.ts-single-outcome .ts-title {
    color: #fff;
    padding: 0px 15px;
}

.ts-single-outcome:hover i {
    -webkit-animation-name: shake;
    animation-name: shake;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}

.outcome-item:nth-of-type(1) .ts-single-outcome {
    background-image: -webkit-linear-gradient(340deg, #fc6076 0%, #ff9a44 100%);
    background-image: -o-linear-gradient(340deg, #fc6076 0%, #ff9a44 100%);
    background-image: linear-gradient(110deg, #fc6076 0%, #ff9a44 100%);
}

.outcome-item:nth-of-type(2) .ts-single-outcome {
    background-image: -webkit-radial-gradient(50% 50%, #57c6e1 0%, #b49fda 0%, #7ac5d8 0%, #eea2a2 0%, #b1aff0 0%, #836df0 100%);
    background-image: -o-radial-gradient(50% 50%, #57c6e1 0%, #b49fda 0%, #7ac5d8 0%, #eea2a2 0%, #b1aff0 0%, #836df0 100%);
    background-image: radial-gradient(50% 50%, #57c6e1 0%, #b49fda 0%, #7ac5d8 0%, #eea2a2 0%, #b1aff0 0%, #836df0 100%);
}

.outcome-item:nth-of-type(3) .ts-single-outcome {
    background-image: -webkit-linear-gradient(135deg, #22ffa4 0%, #43c47a 49%, #10ae23 100%);
    background-image: -o-linear-gradient(135deg, #22ffa4 0%, #43c47a 49%, #10ae23 100%);
    background-image: linear-gradient(-45deg, #22ffa4 0%, #43c47a 49%, #10ae23 100%);
}

.outcome-item:nth-of-type(4) .ts-single-outcome {
    background-image: -webkit-linear-gradient(135deg, #22e1ff 0%, #1d8fe1 49%, #625eb1 100%);
    background-image: -o-linear-gradient(135deg, #22e1ff 0%, #1d8fe1 49%, #625eb1 100%);
    background-image: linear-gradient(-45deg, #22e1ff 0%, #1d8fe1 49%, #625eb1 100%);
}

/**/

.ts-count-down {
    padding: 0;
    margin: -80px 0 0 0;
    z-index: 1;
    position: relative;
}

.gradient {
    background-image: linear-gradient(144deg, #00C0FF 0%, #236CD7 51%, #4218B8 100%);
    width: 100%;
    height: 100%;
    position: relative;
}

.ts-count-down .countdown {
    margin-bottom: 0;
}

.ts-count-down .countdown .counter-item {
    width: 25%;
    float: left;
    margin-right: 0;
    border: none;
    position: relative;
    height: auto;
}

.ts-count-down .countdown .counter-item {
    width: 25%;
    float: left;
    margin-right: 0;
    border: none;
    position: relative;
    height: auto;
}

.countdown .counter-item {
    display: inline-block;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -ms-border-radius: 50%;
    text-align: center;
    color: #fff;
    margin-right: 18px;
    padding: 35px 0;
    position: relative;
}

.countdown .counter-item {
    text-align: center;
    color: #fff;
    font-size: 30px;
}

.countdown .counter-item .smalltext {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 2.5px;
}

.ts-count-down .countdown .counter-item b {
    position: absolute;
    right: 0;
    top: 50%;
    bottom: 0;
    margin: auto;
    font-size: 30px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}

b, strong {
    font-weight: bolder;
}

/*sponsers*/
.ts-intro-sponsors {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    padding: 50px 0 80px;
    font-family: roboto;
}

.section-title.white, .column-title.white {
    color: #fff;
}

.section-title, .column-title {
    font-size: 36px;
    font-weight: 800;
    color: #333;
    position: relative;
    /*text-align: center;*/
    font-family: lora;
}

.section-title span, .column-title span {
    display: block;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    line-height: 26px;
    color: #888888;
    text-transform: uppercase;
    letter-spacing: 1.4px;
    margin-bottom: 10px;
    margin-top: -5px;
}

.section-title.white::after, .column-title.white::after {
    background-image: url('https://shshank.eygb.me/assets/themes/ey/images/shap/title-white.png');
}

.section-title::after, .column-title::after {
    position: absolute;
    left: 0;
    top: 0;
    content: \'\';
    right: 0;
    background-image: url('https://shshank.eygb.me/assets/themes/ey/images/shap/title.png');
    background-repeat: no-repeat;
    background-size: center center;
    background-position: contain;
    width: 70px;
    height: 10px;
    margin: auto auto 0;
    top: auto;
    bottom: 0;
}

.text-center {
    text-align: center !important;
}

a:link, a:visited {
    text-decoration: none;
}

.ts-intro-sponsors .sponsors-logo img {
    margin: 0 38px 50px;
    vertical-align: middle;
}

.btn-sponsor {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    background: #00a0e3;
    height: 50px;
    padding: 15px 35px;
    line-height: 50px;
    border-radius: 3px;
    -webkit-border-radius: 3px;
    -ms-border-radius: 3px;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    outline: none;
    text-decoration: none;
    cursor: pointer;
}

.ra-btn {
    font-size: 14px;
    height: 40px;
    padding: 0 0;
    width: 150px;
    background: #00a0e3;
    color: #fff;
    border: none;
    margin: 5px 5px;
}

.ra-btn:hover {
    box-shadow: 0 6px 8px rgba(0, 0, 0, .2);
    transition: .3s ease;
}

/*--*/
.bottom-social {
    padding: 40px 0;
    background-color: #E9E9E9;
    text-align: center;
    width: 100%;
}

.bottom-social a {
    color: #C3C2C2;
    font-size: 38px;
    margin: 0 25px;
}

/*---*/
.disabled {
    cursor: not-allowed;
}

.full-width-light {
    background-size: 100% !important;
    background-repeat: no-repeat !important;
}

.title-main {
    background: url('https://www.empoweryouth.com/assets/themes/ey/images/pages/webinar/webinar-cover.png');
    height: 80vh;
    background-size: cover;
    background-position: center;
}

.element-percent {
    background: #5e6a6fb8;
    width: 100%;
    margin: 0 auto;
    height: 80vh;
    display: inline-block;
    padding-top: 28vh;
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: center*/
}

.element-percent h1 {
    color: #fff;
    font-weight: 700;
}

.webinar-description p {
    font-size: 17px;
    letter-spacing: .5px;
    text-align: justify;
    line-height: 26px;
    color: #333;
    margin-bottom: 30px;
}

.webinar-description ul {
    padding-left: 20px;
    list-style: circle;
}

.webinar-description ul li {
    margin: 10px;
}

div.icon {
    font-size: 1em; /* change icon size */
    display: block;
    position: relative;
    width: 9em;
    height: 9em;
    margin: 30px auto;
    background-color: #fff;
    border-radius: 0.6em;
    box-shadow: 0 1px 0 #bdbdbd, 0 2px 0 #fff, 0 3px 0 #bdbdbd, 0 4px 0 #fff, 0 5px 0 #bdbdbd, 0 0 0 1px #bdbdbd;
    overflow: hidden;
}

div.icon * {
    display: block;
    width: 100%;
    font-size: 1em;
    font-weight: bold;
    font-style: normal;
    text-align: center;
}

div.icon strong {
    position: absolute;
    top: 0;
    padding: 0.4em 0;
    color: #fff;
    background-color: #00a0e3;
    border-bottom: 1px dashed #00a0e3;
    box-shadow: 0 2px 0 #00a0e3;
}

div.icon em {
    position: absolute;
    bottom: 0.5em;
    color: #00a0e3;
}

div.icon span {
    font-size: 2.8em;
    letter-spacing: -0.05em;
    padding-top: 0.8em;
    color: #2f2f2f;
}

.sidebar h4 {
    margin: 20px 0px !important;
    text-align: center;
}

.register-action {
    display: flex;
}

.speaker-author {
    margin-right: 15px;
    float: left;
    width: 100px;
}

.speaker-author img {
    border-radius: 100%;
    width: 100%;
}

.speaker-content {
    overflow: hidden;
    position: relative;
}

.speaker-content h4 {
    font-size: 15px;
    font-weight: 600;
    margin: 10px 0px !important;
}

.speaker-content p {
    color: #708790;
    line-height: 24px;
    max-width: 100%;
    margin-bottom: 0;
}

.avatars {
    display: flex;
    align-items: center;
    margin-left: -20px;
    justify-content: flex-end;
}

.avatars p {
    font-size: 18px;
    padding-top: 10px;
    margin-left: 40px;
    margin-bottom: 0px;
}

.avatar {
    margin-left: -20px;
    position: relative;
    border: 1px solid #fff;
    border-radius: 50%;
    overflow: hidden;
    width: 40px;
    height: 40px;
}

.avatar img {
    width: 40px;
    height: 40px;
}

#attending.actionColor {
    background: #ff7803;
}

#notInterested.actionColor {
    background: #FF0000;
}

#interested.actionColor {
    background: #32CD32
}

.share-social {
    display: flex;
    align-items: stretch;
    margin: 10px 0;
}

.basis {
    flex-basis: 50%;
}

.whatsapp-share a, .teleg-share a, .twi-share a, .link-share a, .reddit-share a {
    display: block;
    color: #fff;
    padding: 8px 10px;
    font-size: 16px;
    font-family: roboto;
    font-weight: 500;
    margin-right: 10px;
}

.whatsapp-share a {
    background-color: #36dc54;
}

.teleg-share a {
    background-color: #2399d7;
}

.twi-share a {
    background-color: #1da1f2;
}

.link-share a {
    background-color: #0073b1;
}

.reddit-share a {
    background-color: #ff4500;
}

.whatsapp-share a:hover,
.teleg-share a:hover,
.twi-share a:hover,
.link-share a:hover,
.reddit-share a:hover {
    box-shadow: 0 6px 8px rgba(0, 0, 0, .2);
    transition: .3s ease;
}

.ra-btn.active {
    transform: scale(1.05);
    background-color: green;
    box-shadow: 0px 2px 10px 3px #ddd;
}

.joinBtn {
    padding: 35px;
    display: block;
    color: #fff;
    font-size: 25px;
}

.ts-schedule-nav {
    text-align: center;
    margin-bottom: 90px;
}

.ts-schedule-nav ul {
    border: none;
    justify-content: center;
    display: flex;
}

.ts-schedule-nav ul li {
    margin: 0 3px;
}

.ts-schedule-nav ul li a {
    font-size: 12px;
    color: #222222;
    text-transform: uppercase;
    background: #f1f0f6;
    display: block;
    padding: 20px 50px;
    position: relative;
}

.ts-schedule-nav ul li a:before {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 15px 15px 0;
    border-color: transparent #00a0e3 transparent transparent;
    position: absolute;
    left: 0;
    bottom: -15px;
    content: '';
    opacity: 0;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
}

.ts-schedule-nav ul li a h3 {
    font-size: 24px;
    font-weight: 400;
    color: #222222;
    margin-bottom: 0;
    text-transform: capitalize;
}

.ts-schedule-nav ul li.active a {
    background: #00a0e3;
    color: #fff;
}

.ts-schedule-nav ul li.active a h3 {
    color: #fff;
}

.ts-schedule-nav ul li.active a:before {
    opacity: 1;
}

.schedule-listing {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
}

.schedule-listing .schedule-slot-time {
    background: #008fca;
    color: #fff;
    padding: 60px 28px;
    font-size: 18px;
    font-weight: 700;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 18%;
    flex: 0 0 18%;
    max-width: 18%;
}

.schedule-listing .schedule-slot-time span {
    display: inline-block;
    line-height: 26px;
}

.schedule-listing .schedule-slot-info {
    position: relative;
    padding: 35px 40px 35px 170px;
    border: 1px dashed #e5e5e5;
    border-left: none;
    width: 100%;
}

.schedule-listing .schedule-slot-info .schedule-slot-speakers {
    position: absolute;
    left: 40px;
    top: 0;
    height: 80px;
    width: 80px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -ms-border-radius: 50%;
    bottom: 0;
    margin: auto;
}

.schedule-listing .schedule-slot-info .schedule-slot-title {
    font-size: 24px;
}

.schedule-listing .schedule-slot-info .schedule-slot-title strong {
    font-size: 14px;
    color: #888888;
    margin-left: 12px;
}

.schedule-listing .schedule-slot-info p {
    margin-bottom: 0;
}

.schedule-listing:hover .schedule-slot-title {
    color: #3b1d82;
}

.schedule-listing:nth-of-type(even) .schedule-slot-time {
    background: #00a0e3;
}

.ts-book-seat {
    background-image: linear-gradient(110deg, #FF7803 50%, #fff 143%);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    position: relative;
    padding: 40px 0;
}

.ts-book-seat.second {
    background-image: unset;
    background-color: #00008B;
}

.ts-book-seat:after {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    /*background-image: url(../../../public/images/lines-2.png);*/
    content: '';
    background-repeat: no-repeat;
    background-position: center;
    z-index: 0;
}

.ts-book-seat .book-seat-content {
    position: relative;
    z-index: 1;
}

.ts-book-seat .book-seat-content .section-title {
    margin-bottom: 0px;
    font-size: 28px;
    max-width: 600px;
    margin: auto;
    line-height: 40px;
}

.ts-book-seat .book-seat-content .section-title span {
    margin-top: 15px;
    color: #fff;
}

.ts-book-seat .book-seat-content p {
    color: #fff;
    margin-bottom: 20px;
}

.section-title img {
    max-height: 80px;
}

.mb-100 {
    margin-bottom: 100px;
}

.section-list {
    color: #fff;
    text-align: left;
    line-height: 20px;
    max-width: 600px;
    margin: auto;
    list-style: disc;
}

.section-list li {
    font-size: 17px;
}

#register3, #register4 {
    width: auto;
    padding: 0px 20px;
}

@media screen and (min-width: 991px) {
    .md-flex {
        display: flex;
    }
}

@media (max-width: 767px) {
    .section-list {
        padding: 10px 30px;
    }

    .schedule-listing {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .schedule-listing .schedule-slot-time {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        padding: 20px 35px;
    }

    .schedule-listing .schedule-slot-info {
        padding: 35px 40px 35px 35px;
        border-left: 1px dashed #e5e5e5;
    }

    .schedule-listing .schedule-slot-info .schedule-slot-speakers {
        display: none;
    }

    .schedule-listing-btn {
        margin-top: 40px;
    }

    .ts-schedule-nav {
        margin-bottom: 40px;
    }

    .ts-schedule-nav ul li a {
        display: inline-block;
        padding: 20px 20px;
        margin: 5px 0;
    }

    .schedule-tabs-item .schedule-listing-item:before, .schedule-tabs-item .schedule-listing-item:after {
        display: none;
    }

    .schedule-tabs-item .schedule-listing-item.schedule-left {
        margin-top: 0;
        padding: 0px 110px 20px 0;
    }

    .schedule-tabs-item .schedule-listing-item.schedule-right {
        padding: 0px 20px 0px 110px;
        margin-bottom: 30px;
    }

    .schedule-tabs-item .schedule-listing-item .schedule-slot-speakers {
        top: 5px;
    }
}
</style>